import actions from './actions'

export default function AppSettingssReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_APPSETTINGS:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_APPSETTINGS:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_APPSETTINGS:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_APPSETTINGS:
      return {
        ...state,
        editing: { appSettingsID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_APPSETTINGS_RECIEVED ||
      actions.UPDATE_APPSETTINGS_RECIEVED ||
      actions.DELETE_APPSETTINGS_RECIEVED:
      return {
        ...state,
        editing: { appSettingsID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
